import { render, staticRenderFns } from "./AddOtherPurchase.vue?vue&type=template&id=1bcfe491"
import script from "./AddOtherPurchase.vue?vue&type=script&lang=js"
export * from "./AddOtherPurchase.vue?vue&type=script&lang=js"
import style0 from "./AddOtherPurchase.vue?vue&type=style&index=0&id=1bcfe491&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports